const MyOrdersDetailsItemTypes = {
    "chat": "chat",
    "voice": "voice"
};
var my_orders_details_item_type = Object.freeze(MyOrdersDetailsItemTypes);

export { my_orders_details_item_type as default };
//# sourceMappingURL=my_orders_details_item_type.js.map
